import { createGlobalStyle } from "styled-components"
import { normalize } from "styled-normalize"

import { breakpoints, toRem } from "utils/mixins"

import { branding, neutral, palette } from "./colors"
import { fontBody } from "./fonts"
import { container, space } from "./sizes"
import { p, h1, h2, h3, h4 } from "./typography"

export const GlobalStyles = createGlobalStyle`
  ${({ $pageBackground }) =>
    $pageBackground &&
    `
    :root {
      --page-background: ${$pageBackground};
    }
  `}
  ${normalize}

  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }

  html {
    /* 1rem === 16px. The design tokens in theme/fonts.js are expressed in real
       rem (--text-base: 1rem = 16px), so the root must not be shrunk to the
       old 62.5%/10px trick — that rendered the whole scale at 62.5% size.
       utils/mixins.js toRem() divides by 16 to match. */
    font-size: 100%;
  }

  b, strong {
    font-weight: bold;
  }

  img {
    display: block;
  }

  .popup-image {
    border-radius: ${toRem(24)};
    overflow: hidden;
    margin: ${toRem(16)} 0;
    max-width: 100%;
    aspect-ratio: 1.33;
    height: 100%;
    width: 100%;
    flex: 1;

    & > div, img {
      height: 100%;
      width: 100%;
      object-fit: contain;
    }
  }
  
  html,
  body {
    margin: 0;
    padding: 0;
    background: var(--page-background, ${palette.background});
    word-wrap: break-word;
  }

  body {
    background-attachment: fixed;
    visibility: hidden;
    opacity: 0;
    overflow-y: hidden;
    -webkit-font-smoothing: antialiased;
    color: ${palette.dark};
    font-family: ${fontBody};
    -moz-osx-font-smoothing: grayscale;
    cursor: default;
    ${p}

    &.noover {
      overflow: hidden;
    }
  }

  .main {
    min-height: 100vh;
    position: relative;

    @media ${breakpoints.laptop} {
      min-height: 100vh;
    }
    
    &--black {
      background-color: ${neutral.neu02};
      p {
        color: ${neutral.neu01};
      }
    }
  }
  
  .container {
    width: 100%;
    max-width: ${container.default};
    margin: 0 auto;
    position: relative;
    padding: ${space.m} ${space.s};
    &--small {
      max-width: ${container.small};
    }
  }

  .whatsapp_widget_input{
    font-size: 13px!important;
    line-height: 13px!important;
    
    @supports (-webkit-touch-callout: none) {
      /* CSS specific to iOS devices */ 
      font-size: 16px!important;
      line-height: 16px!important;
    }
  }

  input {@supports (-webkit-touch-callout: none) {
      /* CSS specific to iOS devices */ 
      font-size: 16px!important;
      line-height: 16px!important;
    }
  }

  .flex {
    margin-bottom: ${toRem(80)};

    .gatsby-image-wrapper{
      width: 100%;
    }

    .map{
      padding: ${toRem(40)} 0 0 0;
      min-height: ${toRem(600)};
      align-self: stretch;
      
      iframe {
        border: 0;
        min-height: ${toRem(600)};
      }
    }

    @media ${breakpoints.laptop} {
      display: flex;
      //margin-bottom: ${toRem(150)};

      .gatsby-image-wrapper{
        width: 50%;
      }

      .map{
        padding: ${toRem(20)};
        width: 50%;
        align-self: stretch;
      }
    }
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin: 0;
    font-weight: 400;
  }

  h1, .h1 {
    ${h1}
    color: ${palette.dark};
    transition: 250ms;
  }

  h2, .h2 {
    ${h2}
    color: ${palette.dark};
    transition: 250ms;
  }

  h3, .h3 {
    ${h3}
  }

  h4, .h4{
    ${h4}
  }

  p, label {
    ${p}
    margin-bottom: 1em;
  }

  ul {
    margin: 0;
    padding: 0;
    list-style: none;
  }

  img {
    max-width: 100%;
  }

  a { 
    ${h3};
    position: relative;
    font-weight: 300;
    color: ${neutral.neu01};
    color: inherit;
    text-decoration: none;
    transition: 250ms;
    span {
      font-weight: bold;
    }
  }

  button {
    appearance: none;
    display: inline-block;
    border-radius: 0;
    background: none;
    outline: none;
    box-shadow: none;
    border: none;
    padding: 0;
    color: inherit;
    font-size: inherit;
    font-family: inherit;
    cursor: pointer;
    transition: 0.3s;
  }

  address {
    font-style: normal;
  }

  .show {
    display: block;
  }

  .hidden {
    display: none;
  }

  .hide__mobile{
    @media (max-width: 1079px) {
      display: none;
    }
  }

  .show__mobile{
    display: none;
    @media (max-width: 1079px) {
      display: block;
    }
  }

  .react-icons {
  }
`
